<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <div class="card mb-2">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="row mx-1" bis_skin_checked="1">
            <div
              class="col-12 col-md-12 d-flex align-items-center justify-content-between flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-4  mt-md-0"
              bis_skin_checked="1"
            >
              <div class="flex flex-wrap gap-2">
                <div>
                  <label for="">{{ $t("bills.search_from_date") }}</label>
                  <input
                    type="date"
                    v-model="filters.created_at0"
                    class="form-control"
                  />
                </div>
                <div>
                  <label for="">{{ $t("bills.search_to_date") }}</label>
                  <input
                    type="date"
                    v-model="filters.created_at1"
                    class="form-control"
                  />
                </div>
                <div class="flex flex-col align-items-end justify-content-end">
                  <button
                    :disabled="
                      filters.created_at0 == '' || filters.created_at1 == ''
                    "
                    @click.prevent="applyFilters()"
                    class="btn btn-primary"
                  >
                    {{ $t("bills.filter") }}
                  </button>
                </div>
                <div
                  v-if="filters.created_at0 != '' || filters.created_at1 != ''"
                  class="flex flex-col align-items-end justify-content-end"
                >
                  <button
                    @click.prevent="
                      filters.created_at0 = '';
                      filters.created_at1 = '';
                      applyFilters();
                    "
                    class="btn btn-danger"
                  >
                    {{ $t("bills.clear") }}
                  </button>
                </div>
              </div>
              <div
                id="DataTables_Table_0_filter"
                class="dataTables_filter"
                bis_skin_checked="1"
              >
                <label>
                  <input
                    type="search"
                    class="form-control"
                    @change="applyFilters"
                    v-model="filters.search_query"
                    :placeholder="$t('control.search')"
                    aria-controls="DataTables_Table_0"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row mx-1 mt-n6 mt-4  mt-md-0" bis_skin_checked="1">
            <div
              class="col-12 col-md-9 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
              bis_skin_checked="1"
            >
              <div
                class="dataTables_length"
                id="DataTables_Table_0_length"
                bis_skin_checked="1"
              >
                <label
                  >{{ $t("control.show") }}
                  <select
                    name="DataTables_Table_0_length"
                    aria-controls="DataTables_Table_0"
                    class="form-select"
                    v-model="filters.rows"
                    @change="applyFilters"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="9999999">{{
                      $t("control.rows_all")
                    }}</option>
                  </select>
                </label>
              </div>
            </div>
            <div
              class="col-12 col-md-3 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="btn-group" id="dropdown-icon-demo">
                  <button
                    v-if="hasPrivilege('reports_print')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    type="button"
                    class="btn btn-info dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-upload ti-xs me-2"></i>
                    {{ $t("control.export") }}
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('card_bills_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-printer me-2"></i
                        >{{ $t("control.print") }}</a
                      >
                    </li>
                    <li>
                      <a
                        @click.prevent="
                          export_csv('card_bills_table', 'card_bills')
                        "
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file me-2"></i
                        >{{ $t("control.csv") }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('card_bills_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-text me-2"></i
                        >{{ $t("control.pdf") }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container"
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%; height: 480px;"
            >
              <table
                class="dt-scrollableTable table dataTable no-footer table-hover border-top border-bottom dtr-column table-responsive"
                id="card_bills_table"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead
                  style="background-color: var(--bs-card-bg);"
                  class="sticky top-0 z-50"
                >
                  <tr class="text-nowrap">
                    <th></th>
                    <th>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="allSelected"
                        @click="checkAll"
                      />
                    </th>
                    <th>#</th>
                    <th>{{ $t("bills.code") }}</th>
                    <th>{{ $t("admins.email") }}</th>
                    <th>{{ $t("vouchers_batches.batch_name") }}</th>
                    <th>{{ $t("vouchers_batches.one_voucher_price") }}</th>
                    <th>{{ $t("vouchers_batches.quantity") }}</th>
                    <th>{{ $t("vouchers_batches.total_price") }}</th>
                    <th>{{ $t("vouchers_batches.total_payments") }}</th>
                    <th>{{ $t("vouchers_batches.used_vouchers") }}</th>
                    <th>
                      {{ $t("vouchers_batches.used_vouchers_percentage") }}
                    </th>
                    <th>{{ $t("vouchers_batches.notes") }}</th>
                    <th>{{ $t("vouchers_batches.issued_date") }}</th>
                    <th>{{ $t("vouchers_batches.updated_at") }}</th>
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="filters.id"
                        @change="applyFilters"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="filters.slug"
                        @change="applyFilters"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th>
                      <select
                        v-model="filters.user_id"
                        @change="applyFilters"
                        class="form-select form-select-sm"
                      >
                        <option value="-1">{{ $t("control.all") }}</option>
                        <option
                          v-for="admin in admins"
                          :key="admin.id"
                          :value="admin.id"
                          >{{ admin.email }}</option
                        >
                      </select>
                    </th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>
                      <input
                        type="text"
                        v-model="filters.notes"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th>
                      <input
                        type="text"
                        placeholder="yyyy-mm-dd"
                        style="min-width: 7rem;"
                        dir="ltr"
                        v-model="filters.created_at"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th>
                      <input
                        type="text"
                        placeholder="yyyy-mm-dd"
                        style="min-width: 7rem;"
                        dir="ltr"
                        v-model="filters.updated_at"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 10" :key="index">
                    <th></th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr v-for="(bill, index) in dataList" :key="bill.id">
                    <td>
                      <div class="dropdown" v-if="selection_array.length <= 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <a
                              class="dropdown-item text-primary"
                              href="#"
                              @click="printBill(bill)"
                            >
                              <i class="ti ti-printer me-2"></i
                              >{{ $t("actions.print") }}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td scope="row">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="bill.selected"
                        @click="selectData(bill)"
                      />
                    </td>
                    <td>{{ bill.id }}</td>
                    <td>{{ bill.slug }}</td>
                    <td>{{ bill.user_email }}</td>

                    <td>
                      <div v-if="bill.voucher_batch">
                        <a
                          @click.prevent="
                            this.$router.push({
                              name: 'BatchVouchers',
                              query: { id: bill.voucher_batch.id },
                            })
                          "
                          :href="`/vouchers/batches/${bill.voucher_batch.id}`"
                          >{{ bill.voucher_batch.name }}</a
                        >
                      </div>
                      <div v-else>
                        DELETED
                      </div>
                    </td>
                    <td>
                      <span class="badge bg-label-primary">{{
                        bill.one_voucher_price + settings.currency
                      }}</span>
                    </td>
                    <td>{{ bill.quantity }}</td>
                    <td>
                      <span class="badge bg-label-primary">{{
                        bill.total_price + settings.currency
                      }}</span>
                    </td>
                    <td>
                      <span class="badge bg-label-success">{{
                        bill.used_vouchers_count * bill.one_voucher_price +
                          settings.currency
                      }}</span>
                    </td>
                    <td>{{ bill.used_vouchers_count }}</td>
                    <td>
                      {{ (bill.used_vouchers_count * 100) / bill.quantity }}%
                    </td>
                    <td>{{ bill.notes }}</td>
                    <td>{{ formatDate(bill.created_at) }}</td>
                    <td>{{ formatDate(bill.updated_at) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_info"
                id="DataTables_Table_0_info"
                role="status"
                aria-live="polite"
                bis_skin_checked="1"
              >
                {{
                  $t("control.pagination", {
                    from: meta.from,
                    to: meta.to,
                    total: meta.total,
                  })
                }}
              </div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
                bis_skin_checked="1"
              >
                <ul class="pagination">
                  <li
                    :class="{ disabled: filters.page < 2 }"
                    class="paginate_button page-item previous"
                    id="DataTables_Table_0_previous"
                  >
                    <a
                      @click.prevent="
                        filters.page = filters.page - 1;
                        applyFilters;
                      "
                      aria-controls="DataTables_Table_0"
                      aria-disabled="true"
                      role="link"
                      data-dt-idx="previous"
                      tabindex="-1"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li
                    class="paginate_button page-item"
                    :class="{
                      active: link.label == filters.page,
                      disabled: link.url == null,
                    }"
                    v-for="(link, index) in meta.links"
                    :key="index"
                  >
                    <a
                      v-if="index != 0 && index < meta.links.length - 1"
                      @click.prevent="
                        filters.page = link.label;
                        applyFilters();
                      "
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      aria-current="page"
                      data-dt-idx="0"
                      tabindex="0"
                      class="page-link"
                      >{{ link.label }}</a
                    >
                  </li>
                  <li
                    :class="{
                      disabled: meta.current_page == meta.last_page,
                    }"
                    class="paginate_button page-item next"
                    id="DataTables_Table_0_next"
                  >
                    <a
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      data-dt-idx="next"
                      tabindex="0"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="bill_print_page"
      v-if="selectedBill"
      class="bill-container noScreen"
    >
      <!-- Print button, hidden during printing -->
      <!-- Main bill content -->
      <div class="bill-content">
        <!-- Header with company info -->
        <div class="bill-header text-center">
          <div class="flex justify-center">
            <img :src="server_url + settings.network_logo" class="h-16 w-16" />
          </div>
          <div class="company-name">{{ settings.network_name }}</div>
          <div class="company-name">{{ $t("admins.reseller_bill") }}</div>
        </div>

        <!-- Profile and billing period -->
        <div class="bill-summary">
          <div class="summary-item">
            <span>{{ $t("bills.invoice.bill_to") }}</span>
            <span
              >{{ selectedBill.admin.first_name }}
              {{ selectedBill.admin.last_name }}</span
            >
          </div>
          <div class="summary-item">
            <span>{{ $t("accounts.phone") }}</span>
            <span style="direction: ltr;">{{ selectedBill.admin.phone }}</span>
          </div>
          <div class="summary-item">
            <span>{{ $t("admins.email") }}</span>
            <span style="direction: ltr;">{{ selectedBill.admin.email }}</span>
          </div>
          <div class="summary-item">
            <span>{{ $t("bills.invoice.issued_date") }}</span>
            <span>{{ formatDate(selectedBill.created_at) }}</span>
          </div>
          <div class="summary-item">
            <span>{{ $t("bills.invoice.account_id") }}</span>
            <span>{{ selectedBill.admin.id }}</span>
          </div>
          <div class="summary-item">
            <span>{{ $t("bills.invoice.bill_id") }}</span>
            <span>{{ selectedBill.id }}</span>
          </div>
          <div class="summary-item">
            <span>{{ $t("bills.slug") }}</span>
            <span>{{ selectedBill.slug }}</span>
          </div>
        </div>

        <!-- Itemized table -->
        <table class="bill-table">
          <thead>
            <tr>
              <th colspan="2">{{ $t("bills.invoice.description") }}</th>
              <th>{{ $t("bills.invoice.amount") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="2">{{ $t("bills.price") }}</td>
              <td>
                {{ selectedBill.total_price }}
                <span class="font-bold">{{ settings.currency }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="2">{{ $t("bills.paid") }}</td>
              <td>
                {{ selectedBill.paid }}
                <span class="font-bold">{{ settings.currency }}</span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colspan="2">{{ $t("bills.invoice.remaining") }}</th>
              <th>
                {{ selectedBill.total_price - selectedBill.paid }}
                <span class="font-bold">{{ settings.currency }}</span>
              </th>
            </tr>
          </tfoot>
        </table>

        <!-- Issued by and signature -->
        <div class="bill-issuer">
          <div>{{ $t("bills.invoice.issued_by") }}:</div>
          <div>{{ user.first_name }} {{ user.last_name }}</div>
          <div>{{ formatDate(selectedBill.created_at) }}</div>
          <img
            v-if="user.signature"
            :src="server_url + user.signature"
            class="signature"
          />
        </div>

        <!-- Notes -->
        <div v-if="selectedBill.notes" class="bill-notes">
          <div>{{ $t("bills.notes") }}:</div>
          <div>{{ selectedBill.notes }}</div>
        </div>

        <!-- Footer -->
        <div class="bill-footer">
          <div>{{ settings.network_name }}</div>
          <div style="direction: ltr;">{{ settings.phone_number }}</div>
          <div>{{ settings.status_url }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import {
  export_csv,
  export_pdf,
  hasPrivilege,
  print_element,
  print_table,
} from "../global_constants.js";
import { mapGetters } from "vuex";
export default {
  name: "VouchersBills",
  data() {
    return {
      dataList: null,
      admins: null,
      meta: { last_page: 0 },
      loading: true,
      showFilters: false,
      fullList: false,
      filters: {
        rows: 50,
        page: "",
        id: "",
        slug: "",
        user_email: "",
        total_price: "",
        quantity: "",
        paid: "",
        voucher_batch_name: "",
        notes: "",
        save: false,
        search_query: null,
        created_at0: "",
        created_at1: "",
        created_at: "",
        updated_at: "",
      },
      pdfOptions: {
        margin: 5,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: { scale: 1, dpi: 96, letterRendering: true },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "p",
        },
      },
      format: (date) => {
        const day1 = date[0].getDate();
        const month1 = date[0].getMonth() + 1;
        const year1 = date[0].getFullYear();
        const hour1 = date[0].getHours();
        const minute1 = date[0].getMinutes();

        const day2 = date[1].getDate();
        const month2 = date[1].getMonth() + 1;
        const year2 = date[1].getFullYear();

        return `${day1}-${month1}-${year1} -> ${day2}-${month2}-${year2}`;
      },
      exportFilename: "accounts.pdf",
      current_bills: 0,
      current_paid: 0,
      autoUpdate: false,
      selection_array: [],
      debounce: null,
      loading_overlay: false,
      report_loading: false,
      reportReady: false,
      report: null,
      server_url: localStorage.getItem("server"),
      reportDateStart: "",
      reportDateEnd: "",
      showNotificationConfirm: false,
      notificationMessage: "",
      selectedBill: null,
      allSelected: false,
    };
  },
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  async created() {
    this.prepareFilters();
    this.applyFilters();
    this.fetchAdmins();
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    print_element(id) {
      print_element(id);
    },
    async printBill(bill) {
      this.selectedBill = bill;
      await this.$nextTick();
      await this.print_element("bill_print_page");
    },
    prepareFilters() {
      var filters = localStorage.getItem("vouchers_bills_filters");
      if (filters != null) {
        filters = JSON.parse(filters);
        if (filters.save) this.filters = filters;
        else this.filters.rows = filters.rows;
      }
    },
    async applyFilters() {
      this.loading = true;
      var requestString = "vouchers/batches/bills?filters=1";
      if (this.filters.page != "")
        requestString += `&page=${this.filters.page}`;
      if (this.filters.rows != "")
        requestString += `&rows=${this.filters.rows}`;
      if (this.filters.id != "") requestString += `&id=${this.filters.id}`;
      if (this.filters.user_email != "" && this.filters.user_email != -1)
        requestString += `&user_email=${this.filters.user_email}`;
      if (this.filters.slug != "")
        requestString += `&slug=${this.filters.slug}`;
      if (this.filters.total_price != "")
        requestString += `&total_price=${this.filters.total_price}`;
      if (this.filters.quantity != "")
        requestString += `&quantity=${this.filters.quantity}`;
      if (this.filters.paid != "")
        requestString += `&paid=${this.filters.paid}`;
      if (this.filters.voucher_batch_name != "")
        requestString += `&voucher_batch_name=${this.filters.voucher_batch_name}`;
      if (this.filters.notes != "")
        requestString += `&notes=${this.filters.notes}`;
      if (this.filters.search_query != null)
        requestString += `&search_query=${this.filters.search_query}`;
      if (this.filters.created_at != "") {
        // this.filters.created_at = [
        //   moment(this.filters.created_at[0]).format("yyyy-MM-DD"),
        //   moment(this.filters.created_at[1]).format("yyyy-MM-DD"),
        // ];
        requestString += `&created_at_string=${this.filters.created_at}`;
      }
      if (this.filters.updated_at != "") {
        // this.filters.updated_at = [
        //   moment(this.filters.updated_at[0]).format("yyyy-MM-DD"),
        //   moment(this.filters.updated_at[1]).format("yyyy-MM-DD"),
        // ];
        requestString += `&updated_at_string=${this.filters.updated_at}`;
      }
      if (this.filters.created_at0 != "") {
        this.filters.created_at0 = moment(this.filters.created_at0).format(
          "yyyy-MM-DD",
        );
        requestString += `&created_at0=${this.filters.created_at0}`;
      }
      if (this.filters.created_at1 != "") {
        this.filters.created_at1 = moment(this.filters.created_at1).format(
          "yyyy-MM-DD",
        );
        requestString += `&created_at1=${this.filters.created_at1}`;
      }
      if (this.sort_col)
        requestString += `&order_by=${this.sort_col}&order_dir=${this.sort_dir}`;
      const response = await axios.get(requestString);
      this.dataList = response.data.data;
      if (this.filters.save)
        localStorage.setItem(
          "card_bills_filters",
          JSON.stringify(this.filters),
        );
      this.current_bills = 0;
      this.current_paid = 0;
      this.dataList.forEach((bill) => {
        this.current_bills += bill.total_price;
        this.current_paid += Math.abs(bill.paid);
      });
      if (this.dataList.length < 1 && this.filters.page != 1) {
        this.filters.page = 1;
        this.applyFilters();
      }
      if (this.sort_col) {
        if (this.sort_dir == "ASC") {
          this.dataList.sort((a, b) =>
            a[this.sort_col] > b[this.sort_col]
              ? 1
              : b[this.sort_col] > a[this.sort_col]
              ? -1
              : 0,
          );
        } else {
          this.dataList.sort((a, b) =>
            a[this.sort_col] < b[this.sort_col]
              ? 1
              : b[this.sort_col] < a[this.sort_col]
              ? -1
              : 0,
          );
        }
      }
      this.meta = response.data.meta;
      this.loading = false;
    },
    checkAll() {
      if (this.allSelected) {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = false;
        });
        this.allSelected = false;
      } else {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = true;
          this.selection_array.push(element);
        });
        this.allSelected = true;
      }
    },
    selectData(data) {
      if (data.selected == false) {
        data.selected = true;
        this.selection_array.push(data);
      } else {
        data.selected = false;
        this.selection_array.splice(this.selection_array.indexOf(data), 1);
      }
    },
    async fetchAdmins() {
      const response = await axios.get("adminslog/admins");
      if (response.status == 200) {
        this.admins = response.data.data;
      }
    },
    async fetchDataPortion(rows, currentPage) {
      this.filters.rows = rows;
      this.filters.page = currentPage;
      this.applyFilters();
    },
    formatDate(date) {
      return moment(date).format("yyyy-MM-DD hh:mm a");
    },
    async toggleAutoUpdate() {
      this.autoUpdate = !this.autoUpdate;
      while (this.autoUpdate) {
        this.applyFilters();
        await new Promise((r) => setTimeout(r, 30000));
      }
    },
    toggleSaveFilters() {
      this.filters.save = !this.filters.save;
      localStorage.setItem("bills_filters", JSON.stringify(this.filters));
    },
    print_element(element_id) {
      // Get HTML to print from element
      const prtHtml = document.getElementById(element_id).innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0",
      );

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          <link href="/js/about.js" rel="prefetch">
          <link href="/styles/app.scss" rel="stylesheet">
          <link href="/styles/main.css" rel="stylesheet">
          ${stylesHtml}
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      // WinPrint.close();
    },
    export_csv(table_id, file_name) {
      return export_csv(table_id, file_name);
    },
    export_pdf(table_id, file_name) {
      return export_pdf(table_id, file_name);
    },
    print_table(id) {
      print_table(id);
    },
  },
};
</script>
<style scoped>
/* Screen styles for preview */
.bill-container {
  margin: 20px auto;
  padding: 10mm;
  background: white;
  font-family: Arial, sans-serif;
}

.bill-content {
  color: black;
  background: white;
}

.bill-header,
.bill-details,
.bill-summary,
.bill-issuer,
.bill-notes,
.bill-footer {
  margin-bottom: 10mm;
}

.bill-header,
.bill-footer {
  text-align: center;
}

.company-logo,
.signature {
  max-height: 80px;
}

.company-name {
  font-size: 1.5rem;
  font-weight: bold;
}

.bill-details {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.customer-info,
.invoice-info {
  flex: 1;
}

.info-row,
.summary-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.bill-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 10mm;
}

.bill-table th,
.bill-table td {
  border: 1px solid black;
  padding: 5pt;
  text-align: left;
}

.bill-table th {
  background-color: #f2f2f2;
}

.bill-table tfoot {
  font-weight: bold;
}

.print-button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  margin-bottom: 10mm;
}

.print-button:hover {
  background-color: #0056b3;
}

/* Print-specific styles */
@media print {
  .print-button {
    display: none;
  }

  .bill-container {
    margin: 0;
    padding: 5mm;
    font-size: 10pt;
    color: black;
    background: white;
  }

  .bill-table th,
  .bill-table td {
    border: 1px solid black;
    padding: 3pt;
  }

  .bill-table th {
    background: none; /* Remove background for B&W */
  }

  .bill-table,
  .bill-details,
  .bill-summary,
  .bill-issuer,
  .bill-notes {
    page-break-inside: avoid;
  }

  @page {
    size: A4;
    margin: 5mm;
  }

  body * {
    visibility: hidden;
  }

  .bill-container,
  .bill-container * {
    visibility: visible;
  }

  .bill-container {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
